import ScrollReveal from "components/common/ScrollReveal";

const STATS = [
    { value: "20+", label: "Years Experience" },
    { value: "24/7", label: "Support Available" },
    { value: "100+", label: "Enterprise Clients" },
    { value: "15+", label: "Technology Partners" },
];

const StatsBar = () => {
    return (
        <section className="py-10 md:py-12 -mt-8 relative z-10">
            <div className="container">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                    {STATS.map((stat, index) => (
                        <ScrollReveal
                            key={stat.label}
                            variant="up"
                            delay={index * 100}
                        >
                            <div className="stat-card">
                                <div className="text-3xl md:text-4xl font-bold text-primary mb-1">
                                    {stat.value}
                                </div>
                                <div className="text-sm md:text-base text-secondary/70">
                                    {stat.label}
                                </div>
                            </div>
                        </ScrollReveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StatsBar;
